"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = _styledComponents.default.ul.withConfig({
  displayName: "List",
  componentId: "em8ipz-0"
})(["width:320px;background:", ";margin:0;padding:0;padding-inline-start:0;"], (0, _helpers.color)('white'));

var Submenu = function Submenu(props) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("svg", {
    style: {
      visibility: 'hidden',
      position: 'absolute'
    }
  }, _react.default.createElement("defs", null, _react.default.createElement("filter", {
    id: "whiteOut",
    filterUnits: "userSpaceOnUse"
  }, _react.default.createElement("feColorMatrix", {
    colorInterpolationFilters: "sRGB",
    type: "matrix",
    values: "1 1 1 1 0 1 1 1 1 0 1 1 1 1 0 0 0 0 1 0 "
  })))), _react.default.createElement("nav", null, _react.default.createElement(List, props)));
};

var _default = Submenu;
exports.default = _default;